import { useEffect, useState } from 'react';
import { loadActiveAnnouncement } from '../lib/announcementsService';
import { bannerStyle, bannerText, type NetworkAnnouncement } from '../lib/announcements';

/**
 * Bandeau d'annonce réseau (brique A) — affiché en haut de TOUS les sites
 * (client, tablette, back-office) quand le super_admin a publié une annonce active :
 * panne, maintenance, déploiement, info. Source unique Supabase (lecture publique).
 *
 * Discret par conception : si aucune annonce live, n'affiche rien (return null).
 * Tolérant : toute erreur de chargement = pas de bandeau (un site ne doit jamais
 * planter à cause d'une annonce).
 */
export default function NetworkBanner() {
  const [announcement, setAnnouncement] = useState<NetworkAnnouncement | null>(null);

  useEffect(() => {
    let cancelled = false;
    loadActiveAnnouncement()
      .then((a) => {
        if (!cancelled) setAnnouncement(a);
      })
      .catch(() => {
        /* silencieux : pas de bandeau en cas d'erreur */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!announcement) return null;

  return (
    <div
      role="status"
      className="w-full text-center text-sm font-semibold px-4 py-2"
      style={bannerStyle(announcement.severity)}
    >
      {bannerText(announcement)}
    </div>
  );
}
